import { Topic, InAppNotification } from '@jupiterone/notification-types';

const TIMESTAMP = 1116475200000;

export const generateMockNotifications = () =>
  Object.values(Topic).map(
    (topic, index) =>
      ({
        notificationId: `${index}`,
        topic,
        body: {
          message: '',
        },
        createdAt: TIMESTAMP,
        actionLink: '',
        ...(index !== 0 && { readDate: TIMESTAMP }),
      } as InAppNotification)
  );
